var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "nup_main",
      attrs: { "element-loading-text": "拼命加载中" }
    },
    [
      _c("learnCardBind", {
        attrs: { value: _vm.showLearnCardBind },
        on: {
          "update:value": function($event) {
            _vm.showLearnCardBind = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.projCourseList && _vm.projCourseList.length == 0
        ? _c("div", { staticClass: "new_user_project_noSource" }, [
            _vm._v(
              "\n    此培训班为考试类项目，请点击上方“我的练习”或“我的考试”完成您的培训。"
            ),
            _c("br"),
            _vm._v("如需咨询请拨打客服电话："),
            _c("span", [_vm._v("400-822-2055")])
          ])
        : _c("div", { staticClass: "nupm_rightAll" }, [
            _c(
              "span",
              {
                staticStyle: {
                  position: "absolute",
                  display: "block",
                  "line-height": "36px",
                  color: "#FF0000",
                  "font-size": "14px",
                  left: "190px",
                  top: "0"
                }
              },
              [_vm._v(_vm._s(_vm.dueToRemind))]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "nupmr_main" }, [
              _c("div", { staticClass: "nupmrm_case" }, [
                _c(
                  "div",
                  {
                    staticClass: "npm_caseDiv1",
                    staticStyle: {
                      height: "auto",
                      "padding-top": "6px",
                      "padding-bottom": "10px",
                      "padding-left": "0px"
                    }
                  },
                  [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(_vm._s(_vm.currentTraining.trainingNotice))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.currentTraining.learnState &&
                (_vm.currentTraining.learnState.compulsoryHourSetting != 0 ||
                  _vm.currentTraining.learnState.electivesHourSetting != 0)
                  ? _c(
                      "div",
                      {
                        staticClass: "npm_caseDiv1",
                        staticStyle: {
                          height: "auto",
                          "padding-top": "6px",
                          "padding-bottom": "10px"
                        }
                      },
                      [
                        _c("div", { staticClass: "npm_caseDiv1_left" }, [
                          _vm._v("学习进度：")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "npm_caseDiv1_right" },
                          [
                            _vm.currentTraining.learnState
                              .compulsoryHourSetting != 0
                              ? _c("el-progress", {
                                  staticStyle: {
                                    width: "450px",
                                    display: "inline-block"
                                  },
                                  attrs: {
                                    percentage: parseInt(
                                      _vm.currentTraining.learnState
                                        .compulsoryProgress
                                    ),
                                    "stroke-width": 16,
                                    "text-inside": true
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentTraining.hourShow == 0 &&
                            _vm.currentTraining.learnState
                              .compulsoryHourSetting != 0 &&
                            _vm.currentTraining.learnState.compulsoryProgress !=
                              100
                              ? _c(
                                  "span",
                                  { staticClass: "npm_caseDiv1_right_info" },
                                  [
                                    _vm._v("(已完成"),
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentTraining.learnState
                                              .compulsoryHour
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _vm._v("学时，需完成必修课程"),
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentTraining.learnState
                                              .compulsoryHourSetting
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _vm._v("学时)")
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "npm_caseDiv1_right" },
                          [
                            _vm.currentTraining.learnState
                              .electivesHourSetting != 0
                              ? _c("el-progress", {
                                  staticStyle: {
                                    width: "450px",
                                    display: "inline-block"
                                  },
                                  attrs: {
                                    percentage: parseInt(
                                      _vm.currentTraining.learnState
                                        .electivesProgress
                                    ),
                                    "stroke-width": 16,
                                    "text-inside": true
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentTraining.hourShow == 0 &&
                            _vm.currentTraining.learnState
                              .electivesHourSetting != 0
                              ? _c(
                                  "span",
                                  { staticClass: "npm_caseDiv1_right_info" },
                                  [
                                    _vm._v("(已完成"),
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentTraining.learnState
                                              .electivesHour
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _vm._v("学时，需完成选修课程"),
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentTraining.learnState
                                              .electivesHourSetting
                                          ) +
                                          " "
                                      )
                                    ]),
                                    _vm._v("学时)")
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "npm_caseDiv1" }, [
                  _c("div", { staticClass: "npm_caseDiv1_left" }, [
                    _vm._v("课程状态：")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "npm_caseDiv1_right" }, [
                    _c(
                      "label",
                      {
                        class: {
                          new_radio_sel: _vm.queryParam.courseState == ""
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.queryParam.courseState,
                              expression: "queryParam.courseState"
                            }
                          ],
                          attrs: {
                            name: "projState",
                            type: "radio",
                            value: ""
                          },
                          domProps: {
                            checked: _vm._q(_vm.queryParam.courseState, "")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.queryParam, "courseState", "")
                            }
                          }
                        }),
                        _vm._v("全部")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        class: {
                          new_radio_sel: _vm.queryParam.courseState == "0"
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.queryParam.courseState,
                              expression: "queryParam.courseState"
                            }
                          ],
                          attrs: {
                            name: "projState",
                            type: "radio",
                            value: "0"
                          },
                          domProps: {
                            checked: _vm._q(_vm.queryParam.courseState, "0")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.queryParam,
                                "courseState",
                                "0"
                              )
                            }
                          }
                        }),
                        _vm._v("未学习")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        class: {
                          new_radio_sel: _vm.queryParam.courseState == "1"
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.queryParam.courseState,
                              expression: "queryParam.courseState"
                            }
                          ],
                          attrs: {
                            name: "projState",
                            type: "radio",
                            value: "1"
                          },
                          domProps: {
                            checked: _vm._q(_vm.queryParam.courseState, "1")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.queryParam,
                                "courseState",
                                "1"
                              )
                            }
                          }
                        }),
                        _vm._v("学习中")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        class: {
                          new_radio_sel: _vm.queryParam.courseState == "2"
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.queryParam.courseState,
                              expression: "queryParam.courseState"
                            }
                          ],
                          attrs: {
                            name: "projState",
                            type: "radio",
                            value: "2"
                          },
                          domProps: {
                            checked: _vm._q(_vm.queryParam.courseState, "2")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.queryParam,
                                "courseState",
                                "2"
                              )
                            }
                          }
                        }),
                        _vm._v("已学完")
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "npm_caseDiv9" }, [
                  _c("div", { staticClass: "npm_caseDiv9_left" }, [
                    _vm._v("课程性质：")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "npm_caseDiv9_right" }, [
                    _c(
                      "ul",
                      { staticClass: "i_nav-012" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.queryParam.compulsory,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "compulsory", $$v)
                              },
                              expression: "queryParam.compulsory"
                            }
                          },
                          [
                            _c("el-radio-button", { attrs: { label: "" } }, [
                              _vm._v("全部")
                            ]),
                            _vm._v(" "),
                            _c("el-radio-button", { attrs: { label: "1" } }, [
                              _vm._v("必修")
                            ]),
                            _vm._v(" "),
                            _c("el-radio-button", { attrs: { label: "0" } }, [
                              _vm._v("选修")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.queryParam.keyword,
                          expression: "queryParam.keyword"
                        }
                      ],
                      attrs: {
                        id: "teacherOrCourseName",
                        placeholder: "课程名称/主讲人",
                        type: "text"
                      },
                      domProps: { value: _vm.queryParam.keyword },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.queryParam,
                            "keyword",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "button", value: "搜索" },
                      on: { click: _vm.search }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "npm_xflx_sqxf" },
                      [
                        _vm.currentTraining.creditHave == "0" &&
                        _vm.currentTraining.creditApplyType == 0
                          ? [
                              _vm.currentTraining.learnState.trainingStatus ==
                                2 &&
                              _vm.currentTraining.learnState.applyCredit ==
                                false
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.applyScoreShow,
                                          expression: "applyScoreShow"
                                        }
                                      ],
                                      staticClass: "small_abtn jjmx_btn_sqxf1",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.applyScore(
                                            _vm.currentTraining.id,
                                            _vm.currentTraining.creditTypeName,
                                            _vm.currentTraining.creditValue
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("申请学分")]
                                  )
                                : _vm.currentTraining.learnState
                                    .trainingStatus == 3 &&
                                  _vm.currentTraining.learnState.applyCredit ==
                                    false
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "small_abtn",
                                      staticStyle: {
                                        "background-color": "#999999"
                                      },
                                      attrs: { href: "javascript:" }
                                    },
                                    [_vm._v("已申请学分")]
                                  )
                                : _vm.currentTraining.learnState.applyCredit ==
                                  true
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "small_abtn",
                                      staticStyle: {
                                        "background-color": "#999999"
                                      },
                                      attrs: { href: "javascript:" }
                                    },
                                    [_vm._v("已授予学分")]
                                  )
                                : _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        content: "未完成学习，不可申请学分",
                                        effect: "dark",
                                        placement: "right"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "small_abtn",
                                          staticStyle: {
                                            "background-color": "#999999"
                                          },
                                          attrs: {
                                            id: "grayBut",
                                            href: "javascript:"
                                          }
                                        },
                                        [_vm._v("申请学分")]
                                      )
                                    ]
                                  )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentTraining.creditHave == "0" &&
                        _vm.currentTraining.creditShow == 0
                          ? _c("b", [
                              _vm._v(
                                _vm._s(_vm.currentTraining.projectTypeName) +
                                  "\n                " +
                                  _vm._s(_vm.currentTraining.creditTypeName) +
                                  " " +
                                  _vm._s(_vm.currentTraining.creditValue) +
                                  "分"
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "nupmrm_content" },
                [
                  _vm.projCourseList && _vm.projCourseList.length > 0
                    ? _c(
                        "el-collapse",
                        {
                          model: {
                            value: _vm.activeNames,
                            callback: function($$v) {
                              _vm.activeNames = $$v
                            },
                            expression: "activeNames"
                          }
                        },
                        _vm._l(_vm.projCourseList, function(item, index) {
                          return _c(
                            "el-collapse-item",
                            { key: item.id, attrs: { name: index + 1 } },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  "\n              " + _vm._s(item.projectName)
                                ),
                                _vm.currentTraining.hourShow == 0
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          "margin-right": "30%"
                                        }
                                      },
                                      [
                                        _c(
                                          "b",
                                          { staticStyle: { color: "#38BCD5" } },
                                          [_vm._v(_vm._s(item.totalHour))]
                                        ),
                                        _vm._v("学时")
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "collapse ba br2 b--black-10 pv1 ph1 w-100",
                                  staticStyle: { "text-align": "center" }
                                },
                                [
                                  _c(
                                    "tbody",
                                    [
                                      _c(
                                        "tr",
                                        { staticClass: "striped--near-white" },
                                        [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "pv1 ph3 tl f6 fw6 ttu",
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [_vm._v("序号")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "f6 ttu fw6 pv1 ph1",
                                              attrs: { width: "40%" }
                                            },
                                            [_vm._v("课程名称")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "f6 ttu fw6 pv1 ph1"
                                            },
                                            [_vm._v("课程性质")]
                                          ),
                                          _vm._v(" "),
                                          _vm.currentTraining.hourShow == 0
                                            ? _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "f6 ttu fw6 pv1 ph1"
                                                },
                                                [_vm._v("学时")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "f6 ttu fw6 pv1 ph1"
                                            },
                                            [_vm._v("主讲人")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "f6 ttu fw6 pv1 ph1"
                                            },
                                            [_vm._v("课程状态")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "f6 ttu fw6 pv1 ph0",
                                              attrs: { colspan: "3" }
                                            },
                                            [_vm._v("操作")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(item.courseList, function(
                                        childItem,
                                        index
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            staticClass: "striped--near-white"
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "pv1 ph0",
                                                staticStyle: {
                                                  "text-align": "center"
                                                }
                                              },
                                              [_vm._v(_vm._s(index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "pv1 ph1",
                                                staticStyle: {
                                                  "text-align": "left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      content: childItem.name,
                                                      effect: "dark",
                                                      placement: "top-start"
                                                    }
                                                  },
                                                  [
                                                    childItem.courseVideoNull
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "course_name overflow",
                                                            staticStyle: {
                                                              "max-width":
                                                                "470px",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              overflow:
                                                                "hidden",
                                                              "white-space":
                                                                "nowrap",
                                                              display: "block"
                                                            },
                                                            attrs: {
                                                              title:
                                                                childItem.name,
                                                              href:
                                                                "javascript:"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                childItem.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "course_name overflow",
                                                            staticStyle: {
                                                              "max-width":
                                                                "470px",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              overflow:
                                                                "hidden",
                                                              "white-space":
                                                                "nowrap",
                                                              display: "block"
                                                            },
                                                            attrs: {
                                                              title:
                                                                childItem.name,
                                                              href:
                                                                "javascript:"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openVideoware(
                                                                  childItem,
                                                                  item.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                childItem.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pv1 ph1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    childItem.ybsProjectCourse
                                                      .compulsory == 1
                                                      ? "必修"
                                                      : "选修"
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.currentTraining.hourShow == 0
                                              ? _c(
                                                  "td",
                                                  { staticClass: "pv1 ph1" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        childItem
                                                          .ybsProjectCourse
                                                          .classHour
                                                      ) + "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pv1 ph1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    childItem.ybsRbacUser
                                                      .nickName
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pv1 ph1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.courseStateComputed(
                                                      childItem.ybsCourseState
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pv1 ph0" },
                                              [
                                                childItem.courseVideoNull
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass: "k1-1",
                                                        staticStyle: {
                                                          "padding-right": "0px"
                                                        },
                                                        attrs: {
                                                          href: "javascript:"
                                                        }
                                                      },
                                                      [_vm._v("视频[无]")]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass: "k1",
                                                        staticStyle: {
                                                          "padding-right": "0px"
                                                        },
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openVideoware(
                                                              childItem,
                                                              item.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("视频")]
                                                    )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pv1 ph0" },
                                              [
                                                childItem.practiceNull
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass: "k3-3",
                                                        staticStyle: {
                                                          "padding-right": "0px"
                                                        },
                                                        attrs: {
                                                          href: "javascript:"
                                                        }
                                                      },
                                                      [_vm._v("练习[无]")]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass: "k3",
                                                        staticStyle: {
                                                          "padding-right": "0px"
                                                        },
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.haveBandedLearningCard(
                                                              item.id,
                                                              childItem.id,
                                                              childItem.courseFieldID,
                                                              childItem.name
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    练习[" +
                                                            _vm._s(
                                                              childItem.ybsCourseState &&
                                                                typeof childItem
                                                                  .ybsCourseState
                                                                  .practiseScore !=
                                                                  "undefined" &&
                                                                childItem
                                                                  .ybsCourseState
                                                                  .practiseScore !=
                                                                  null
                                                                ? "最高" +
                                                                    childItem
                                                                      .ybsCourseState
                                                                      .practiseScore +
                                                                    "分"
                                                                : "未练"
                                                            ) +
                                                            "]\n                  "
                                                        )
                                                      ]
                                                    )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "pv1 ph0" },
                                              [
                                                childItem.handoutNull
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass: "k2-2",
                                                        staticStyle: {
                                                          "padding-right": "0px"
                                                        },
                                                        attrs: {
                                                          href: "javascript:"
                                                        }
                                                      },
                                                      [_vm._v("讲义[无]")]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        staticClass: "k2",
                                                        staticStyle: {
                                                          "padding-right": "0px"
                                                        },
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openCourseware(
                                                              _vm
                                                                .currentTraining
                                                                .id,
                                                              item.id,
                                                              childItem.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("讲义")]
                                                    )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              item.courseList.length == 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        border: "1px ridge",
                                        "text-align": "center"
                                      }
                                    },
                                    [_vm._v("暂无相关课程")]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        1
                      )
                    : _c(
                        "p",
                        {
                          staticStyle: { width: "100%", "text-align": "center" }
                        },
                        [
                          _vm._v(
                            "没有找到符合要求的课程;若有疑问请拨打客服电话："
                          ),
                          _c("span", [_vm._v("400-822-2055")])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.currentTraining.trainingType == 106100 &&
                  _vm.studyTrainingThinking
                    ? _c(
                        "el-collapse",
                        [
                          _c(
                            "el-collapse-item",
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  "\n              住院医师规范化培训临床思维训练\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "collapse ba br2 b--black-10 pv2 ph3 w-100"
                                },
                                [
                                  _c("tbody", [
                                    _c(
                                      "tr",
                                      { staticClass: "striped--near-white" },
                                      [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "pv2 ph3 tl f6 fw6 ttu"
                                          },
                                          [_vm._v("序号")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          { staticClass: "f6 ttu fw6 pv2 ph3" },
                                          [_vm._v("课程名称")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          { staticClass: "f6 ttu fw6 pv2 ph3" },
                                          [_vm._v("课程性质")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          { staticClass: "f6 ttu fw6 pv2 ph3" },
                                          [_vm._v("主讲人")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          { staticClass: "f6 ttu fw6 pv2 ph3" },
                                          [_vm._v("操作")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tr",
                                      { staticClass: "striped--near-white" },
                                      [
                                        _c("td", { staticClass: "pv2 ph3" }, [
                                          _vm._v("1")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "pv2 ph3" },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  content:
                                                    "住院医师规范化培训临床思维训练",
                                                  effect: "dark",
                                                  placement: "top-start"
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "course_name overflow",
                                                    attrs: {
                                                      title:
                                                        "住院医师规范化培训临床思维训练",
                                                      href: "javascript:",
                                                      onclick: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "住院医师规范化培训临床思维训练"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "pv2 ph3" }, [
                                          _vm._v("选修")
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "pv2 ph3" }, [
                                          _vm._v("医博士")
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "pv2 ph3" }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.thinkingPractiseUrl +
                                                  "?userid=" +
                                                  _vm.userInfo.id,
                                                target: "_blank"
                                              }
                                            },
                                            [_vm._v("开始训练")]
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nupmr_title" }, [
      _c(
        "a",
        { staticClass: "new_myCourse_sel", attrs: { href: "javascript:" } },
        [_vm._v("我的课程")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5afb22c7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afb22c7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotCmePage.vue
// module id = null
// module chunks = 